// extracted by mini-css-extract-plugin
export default {"noMargin":"noMargin__hBrd1"};